import React, { useState, useEffect, useRef } from "react";
import "./AnnuaireEtudiantContainer.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import EtudiantCard from "../EtudiantCard/EtudiantCard";
import AnnuaireEtudiantSearchBar from "../AnnuaireEtudiantSearchBar/AnnuaireEtudiantSearchBar";
import ButtonsBarDisconnected from "Components/Header/ButtonsBarDisconnected/ButtonsBarDisconnected";
import Header from "Components/Header/Header";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import { Dropdown } from "primereact/dropdown";
import { Accordion } from "primereact/accordion";
import { AccordionTab } from "primereact/accordion";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import Loader from "Components/Loader/loader";

const AnnuaireEtudiantContainer = (props) => {
  const annuaireContainerRef = useRef(null);
  const [triEtudiants, setTriEtudiants] = useState(null);
  const triEtudiantsData = [
    { label: "Par défaut", value: "Default" },
    { label: "Par domaine de formation", value: "Domaine formation" },
  ];

  // données qui seront en props pour la recherche

  const [urlAnnuaire, setUrlAnnuaire] = useState(null);
  const usersQuery = useFetchGetPagination(urlAnnuaire, props.auth.token);

  useEffect(() => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/users/annuaire`);
    url.searchParams.set("datasVisibleForAllMembers", 1);
    url.searchParams.set("role", "student");
    setUrlAnnuaire(url);
  }, []);

  const orderStudents = (orderBy) => {
    let newUrl = new URL(
      `${process.env.REACT_APP_BASE_URL_API}/users/annuaire`
    );

    newUrl.search = urlAnnuaire.search;
    newUrl.searchParams.delete("orderDomains");
    orderBy === "Domaine formation" &&
      newUrl.searchParams.set("orderDomains", "asc");

    setUrlAnnuaire(newUrl);
  };

  return (
    <div>
      <Header
        activeIndex={props.activeIndex}
        setActiveIndex={props.setActiveIndex}
        items={props.items}
      >
        {props.auth.isConnected ? (
          <NavBarTab
            select="annuaire"
            activeIndex={props.activeIndex}
            items={props.items}
          />
        ) : (
          <ButtonsBarDisconnected />
        )}
      </Header>
      <div className="article_offre" id="etudiant">
        <div className="annuaire__container">
          <div className="annuaire__container__title">
            <h1 className="h1_trait_dessus">
              {
                props.items.itemsAnnuaire.find(
                  (item) => item.label === props.items.activeItemAnnuaire.label
                ).label
              }
            </h1>
            {usersQuery?.data?.length > 0 ? (
              <p>{usersQuery?.totalItems} étudiants sur notre réseau</p>
            ) : (
              <p>Aucun profil ne correspond à vos critères</p>
            )}
          </div>

          <div className="annuaire_filtre">
            <div className="annuaire_filtre__label">
              <Dropdown
                value={triEtudiants}
                options={triEtudiantsData}
                onChange={(e) => {
                  setTriEtudiants(e.value);
                  orderStudents(e.value);
                }}
                placeholder="Trier par"
              />
            </div>
          </div>
        </div>
        <>
          <AnnuaireEtudiantSearchBar setUrlAnnuaire={setUrlAnnuaire} />
          <Accordion
            expandIcon="pi pi-sliders-h"
            collapseIcon="pi pi-sliders-h"
          >
            <AccordionTab header="Fitres de recherche">
              <AnnuaireEtudiantSearchBar setUrlAnnuaire={setUrlAnnuaire} />
            </AccordionTab>
          </Accordion>
        </>

        <div className="annuaire__container__cards" ref={annuaireContainerRef}>
          {usersQuery.loaded ? (
            usersQuery?.data?.length > 0 ? (
              usersQuery?.data?.map((etudiant, index) => (
                <EtudiantCard {...etudiant} key={index} />
              ))
            ) : (
              <span>Aucun étudiant ne correspond à votre recherche</span>
            )
          ) : (
            <Loader></Loader>
          )}
        </div>

        <TempPagination
          result={usersQuery}
          refItemParent={annuaireContainerRef}
          rows={50}
        ></TempPagination>
      </div>
    </div>
  );
};

AnnuaireEtudiantContainer.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnuaireEtudiantContainer);
